export function hasDigitalSignaturePermission(permissionType) {
  try {
    const permissions = JSON.parse(localStorage.getItem("permissions") || "{}");
    const digitalSignaturePermission =
      permissions?.vendas?.[permissionType]?.permissoesEspecificas
        ?.assinaturaDigital;

    if (typeof digitalSignaturePermission === "boolean") {
      return digitalSignaturePermission;
    }

    return ["adm", "corporate"].includes(
      localStorage.getItem("userLevel")
    );
  } catch (_) {
    return false;
  }
}
